export default __webpack_public_path__ + "media/images/react_icons/property/bath-834662f3fb242680febe84593f769a54.svg";